var _defs, _rect, _rect2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortraitMock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "6c5512f37f"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "690ba0d944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92.484375 27.671875 L 210.28125 27.671875 L 210.28125 150 L 92.484375 150 Z M 92.484375 27.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8e0c0df71b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 99.234375 27.671875 L 203.53125 27.671875 C 205.320312 27.671875 207.039062 28.382812 208.304688 29.648438 C 209.570312 30.914062 210.28125 32.628906 210.28125 34.421875 L 210.28125 159.710938 C 210.28125 161.5 209.570312 163.21875 208.304688 164.484375 C 207.039062 165.75 205.320312 166.460938 203.53125 166.460938 L 99.234375 166.460938 C 97.441406 166.460938 95.726562 165.75 94.460938 164.484375 C 93.195312 163.21875 92.484375 161.5 92.484375 159.710938 L 92.484375 34.421875 C 92.484375 32.628906 93.195312 30.914062 94.460938 29.648438 C 95.726562 28.382812 97.441406 27.671875 99.234375 27.671875 Z M 99.234375 27.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a3f7ee7725"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#6c5512f37f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#000000",
    y: -15,
    height: 179.999997,
    fillOpacity: 0.65
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae7cfaf958"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.96875 0.671875 L 139.496094 0.671875 L 139.496094 26.109375 L 0.96875 26.109375 Z M 0.96875 0.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa16375549"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.71875 0.671875 L 132.671875 0.671875 C 134.460938 0.671875 136.175781 1.382812 137.441406 2.648438 C 138.707031 3.914062 139.421875 5.628906 139.421875 7.421875 L 139.421875 19.359375 C 139.421875 21.148438 138.707031 22.867188 137.441406 24.132812 C 136.175781 25.398438 134.460938 26.109375 132.671875 26.109375 L 7.71875 26.109375 C 5.929688 26.109375 4.214844 25.398438 2.949219 24.132812 C 1.679688 22.867188 0.96875 21.148438 0.96875 19.359375 L 0.96875 7.421875 C 0.96875 5.628906 1.679688 3.914062 2.949219 2.648438 C 4.214844 1.382812 5.929688 0.671875 7.71875 0.671875 Z M 7.71875 0.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "031b4d7c92"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 140,
    y: 0,
    height: 27
  })), /*#__PURE__*/React.createElement("mask", {
    id: "7c8a389f28"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#6c5512f37f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#000000",
    y: -15,
    height: 179.999997,
    fillOpacity: 0.65
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "568f090312"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0078125 1.011719 L 110.941406 1.011719 L 110.941406 86.039062 L 0.0078125 86.039062 Z M 0.0078125 1.011719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b45fa0a913"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.757812 1.011719 L 104.007812 1.011719 C 105.796875 1.011719 107.511719 1.722656 108.78125 2.988281 C 110.046875 4.253906 110.757812 5.972656 110.757812 7.761719 L 110.757812 79.289062 C 110.757812 81.078125 110.046875 82.796875 108.78125 84.0625 C 107.511719 85.328125 105.796875 86.039062 104.007812 86.039062 L 6.757812 86.039062 C 4.96875 86.039062 3.25 85.328125 1.984375 84.0625 C 0.71875 82.796875 0.0078125 81.078125 0.0078125 79.289062 L 0.0078125 7.761719 C 0.0078125 5.972656 0.71875 4.253906 1.984375 2.988281 C 3.25 1.722656 4.96875 1.011719 6.757812 1.011719 Z M 6.757812 1.011719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc2453918d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 112,
    y: 0,
    height: 87
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "092ef12b1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 96.007812 33.144531 L 137.050781 33.144531 L 137.050781 47.636719 L 96.007812 47.636719 Z M 96.007812 33.144531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b19be356b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 102.757812 33.144531 L 130.285156 33.144531 C 132.078125 33.144531 133.792969 33.855469 135.058594 35.121094 C 136.324219 36.386719 137.035156 38.101562 137.035156 39.894531 L 137.035156 40.886719 C 137.035156 42.675781 136.324219 44.394531 135.058594 45.660156 C 133.792969 46.925781 132.078125 47.636719 130.285156 47.636719 L 102.757812 47.636719 C 100.96875 47.636719 99.25 46.925781 97.984375 45.660156 C 96.71875 44.394531 96.007812 42.675781 96.007812 40.886719 L 96.007812 39.894531 C 96.007812 38.101562 96.71875 36.386719 97.984375 35.121094 C 99.25 33.855469 100.96875 33.144531 102.757812 33.144531 Z M 102.757812 33.144531 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#edeaea",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#690ba0d944)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8e0c0df71b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 92.484375 27.671875 L 210.28125 27.671875 L 210.28125 166.636719 L 92.484375 166.636719 Z M 92.484375 27.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a3f7ee7725)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 79, 27)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#031b4d7c92)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae7cfaf958)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa16375549)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M 0.96875 0.671875 L 139.398438 0.671875 L 139.398438 26.109375 L 0.96875 26.109375 Z M 0.96875 0.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#7c8a389f28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 96, 61)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc2453918d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#568f090312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b45fa0a913)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59a3ff",
    d: "M 0.0078125 1.011719 L 110.609375 1.011719 L 110.609375 86.039062 L 0.0078125 86.039062 Z M 0.0078125 1.011719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#092ef12b1b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b19be356b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 96.007812 33.144531 L 137.050781 33.144531 L 137.050781 47.636719 L 96.007812 47.636719 Z M 96.007812 33.144531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortraitMock);
export default __webpack_public_path__ + "static/media/portraitMock.fe695da9edf2d130e714721c4104cf05.svg";
export { ForwardRef as ReactComponent };